import React, { memo } from 'react';

import { InventoryCountTabProps } from './InventoryCount.props';
import { InventoryTabContent } from './InventoryTabContent';

export const AllInventory = memo<InventoryCountTabProps>((props) => {
  return <InventoryTabContent {...props}></InventoryTabContent>;
});
